import { render } from "./QuoteWhite.vue?vue&type=template&id=5ead7aeb&scoped=true"
import script from "./QuoteWhite.vue?vue&type=script&lang=js"
export * from "./QuoteWhite.vue?vue&type=script&lang=js"

import "./QuoteWhite.vue?vue&type=style&index=0&id=5ead7aeb&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ead7aeb"]])

export default __exports__